"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const moment_1 = __importDefault(require("moment"));
const WeekdayMobile = () => {
    const weekArray = moment_1.default.weekdaysShort();
    return (react_1.default.createElement("ul", { className: "vbz-calendar-weekday-mobile" }, weekArray.map((weekday) => {
        return react_1.default.createElement("li", { key: weekday }, weekday);
    })));
};
exports.default = WeekdayMobile;
//# sourceMappingURL=WeekdayMobile.js.map